export default {
  DEFAULT_ERROR_RESPONSE: [{}, {
    status: 500
  }],
  INIT_FETCH_CONFIG: {
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin'
  },
  METHODS: {
    GET: 'GET',
    PATCH: 'PATCH',
    POST: 'POST',
    PUT: 'PUT',
    DELETE: 'DELETE'
  }
};